import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { DataService } from '../shared/dataService';
@Component({
  selector: 'app-recoverypassword',
  templateUrl: './recoverypassword.component.html',
  styleUrls: ['./recoverypassword.component.css']
})
export class RecoverypasswordComponent implements OnInit {
  public creds = {
    username : ""
  };
  public messageResult : string ="Se le mando un correo para actualizar su contraseña.";    
  public sendMessage : boolean;
  constructor(private router:Router,private dataService : DataService) { }

  ngOnInit() {
  }


  //|onRecoveryPws
  onFormSubmit()
  {
    console.log("enviar correo con token para recuperar contraseña");
    console.log(this.creds.username); 
    this.messageResult= "Procesando la solicitud."
    this.dataService.getConfirmEmail(this.creds.username)
    .subscribe(success=>
      {
        if(success)
        { //
         // notify("¡Correo enviado!"); 
         // this.router.navigate(["/account"]);
         this.messageResult = "Se a mandado un correo para actualizar su contraseña.";    
        }
      },error=>{
        console.log("error:")
        console.log(error);
        this.messageResult = "Error al intentar recuperar contraseña.";    
      })
    
      this.sendMessage = true; 
  }
}
